<template>
	<section class="wysiwyg">

		<div class="container">

			<div class="wysiwyg__inner">
				<h2
					class='title-one'
					v-if="title"
					v-html='title'
				></h2>
				<span
					v-html="wysiwyg"
					class="body"
				></span>

				<div
					class="cta_wrapper"
					v-if="parsedPrimaryCta"
				>
					<primary-button
						v-if="parsedPrimaryCta"
						:label="parsedPrimaryCta.title"
						:link="parsedPrimaryCta"
					></primary-button>
				</div>

			</div>

		</div>
	</section>
</template>

<script>
import PrimaryButton from './PrimaryButton.vue';

export default {
	data() {
		return {};
	},

	props: {
		section_id: {},
		top_border: {},
		wysiwyg: {},
		primary_cta: {},
		title: {},
		column_choice: {},
	},

	computed: {
		parsedPrimaryCta() {
			if (this.primary_cta) {
				return JSON.parse(this.primary_cta);
			} else {
				return null;
			}
		},

		parsedSecondaryCta() {
			if (this.secondary_cta) {
				return JSON.parse(this.secondary_cta);
			} else {
				return null;
			}
		},
	},

	watch: {},

	methods: {},

	components: {
		PrimaryButton,
	},

	created() {},
	mounted() {
		let wysiwygIcons = document.querySelectorAll('.wysiwyg_icon');

		wysiwygIcons.forEach((element) => {
			window.onscroll = function () {
				var theta = (document.documentElement.scrollTop / 100) % Math.PI;

				element.style.transform = 'rotate(' + theta + 'rad)';
			};
		});
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/RichText.vue